module.exports = __webpack_public_path__ + "static/lframe-contact-us-6e06a81f6673802ccbaad1abbf30c0f8.png";